<script setup lang="ts">
import { onMounted, onBeforeMount } from 'vue'
import { useCache } from '@/hooks/web/useCache'
import { handleWxConfig } from '@/utils/wxwork'
import { Tabbar } from '@/components/Tabbar'
import { Type } from '@/views/Login/type'

const { wsCache } = useCache()
onBeforeMount(() => {
  for (const key in Type) {
    wsCache.set(`dict_sys_${key}`, Type[key])
  }
})

console.log('App mounted')

onMounted(() => {
  handleWxConfig()
})
</script>

<template>
  <div class="w-100% h-100% flex flex-col" style="position: fixed; top: 0; left: 0">
    <div class="w-100% h-0 flex-1">
      <RouterView />
    </div>
    <Tabbar />
  </div>
</template>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
    background: #eff2f7;
    font-style: normal;
    font-family: 'PingFangSC', 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC',
      sans-serif, 'Segoe UI', Arial, sans-serif;
  }
}
</style>
